import React from 'react'
import PropTypes from 'prop-types'

import useRect from '../hooks/useRect'
import Align from './Align.jsx'

function Grid(props) {
  const { items, direction, gap, align } = props
  const [Rect, rect] = useRect()

  const lengthAxis = direction === 'horizontal' ? 'width' : 'height'

  const gapTotal = gap * (items.length - 1)
  const totalFixedSize = items.reduce((acc, { size }) => acc + (size[lengthAxis] ?? 0), 0)
  const baseSize = rect[lengthAxis] - gapTotal - totalFixedSize

  const sizes = items.map(({ size }) => {
    if (typeof size === 'number') {
      // percent size
      return baseSize * size
    }
    // fixed size
    return size[lengthAxis]
  })

  const cumulativePosition = sizes.reduce((acc, curWidth, index, array) => {
    const previousArray = array.slice(0, index)
    const sum = previousArray.map((size) => size + gap).reduce((acc, cur) => acc + cur, 0)
    return [...acc, sum]
  }, [])

  const containerSVGSize = sizes.reduce((acc, cur) => acc + cur, 0) + gapTotal
  const containerSVGSizingProps =
    direction === 'horizontal'
      ? { width: containerSVGSize, height: rect.height }
      : { width: rect.width, height: containerSVGSize }

  const getCoordinates = (index) => {
    if (direction === 'horizontal') {
      return {
        y: 0,
        height: '100%',
        x: cumulativePosition[index],
        width: sizes[index],
      }
    }
    return {
      x: 0,
      width: '100%',
      y: cumulativePosition[index],
      height: sizes[index],
    }
  }

  return (
    <svg className="ai-slide__grid" x={0} y={0} width="100%" height="100%">
      <Rect />
      <Align x={align?.x} y={align?.y} childrenRect={containerSVGSizingProps}>
        <svg {...containerSVGSizingProps}>
          {items.map(({ component }, index) => (
            <svg key={index} {...getCoordinates(index)}>
              <svg x={0} y={0} width="100%" height="100%">
                {component}
              </svg>
            </svg>
          ))}
        </svg>
      </Align>
    </svg>
  )
}

Grid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.node.isRequired,
      size: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired,
    })
  ).isRequired,
  direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
  gap: PropTypes.number.isRequired,
  align: PropTypes.object,
}

Grid.defaultProps = {
  align: {},
}

export default Grid
